export default  {
    component: 'other_sensors_components',
    name: 'other_sensors_components',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Components',
            param: 'components',
            type: 'text',
            description: `Options available for components are mentioned below, which need to be added in comma seperated format.
            - e.g. [energy_meter,soil_sensor,ups]
            - energy_meter
            - ups
            - transformer
            - breaker
            - fireAlarm
            - dcBatteryCharger
            - scadaPanel
            - soil_sensor`
          }
    ]
  }
